<template>
    <el-row class="estimate-simple-table">
        <el-col :sm="8">
            <v-chart ref="pieChart" :option="chartOption" style="width: 100%; height: 350px" />
        </el-col>
        <el-col :sm="16">
            <el-table class="table" :data="tableData" :show-header="false" v-loading="isLoading">
                <el-table-column>
                    <template slot-scope="scope">
                        <template v-if="!scope.row.custom">
                            <span>{{ scope.row.name }}</span>
                            <ahTip v-if="scope.row.tooltip">
                                {{ scope.row.tooltip }}
                            </ahTip>
                        </template>
                        <template v-else>
                            <div class="custom-block">
                                <div class="custom-label">自編</div>
                                <el-input v-model="scope.row.name" width="150"></el-input>
                            </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column width="120" align="right">
                    <template slot-scope="scope">
                        <Money v-if="!scope.row.custom" :v="scope.row.value" round />
                        <MoneyInput v-else v-model="scope.row.value" style="width: 110px" />
                    </template>
                </el-table-column>
                <el-table-column width="100" align="right">
                    <template slot-scope="scope">
                        <span class="cell right percent"> {{ getPercentage(scope.row.value, total) }} % </span>
                    </template>
                </el-table-column>
                <el-table-column width="100">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.custom" @click="$emit('delete', scope.$index)">
                            刪除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-table class="table-bottom" :data="[{}]" :show-header="false">
                <el-table-column>
                    <!-- eslint-disable-next-line vue/no-unused-vars -->
                    <template slot-scope="scope">
                        <div class="summary-block">
                            <el-button @click="$emit('add')">新增</el-button>
                            <div>總計</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="120" align="right">
                    <!-- eslint-disable-next-line vue/no-unused-vars -->
                    <template slot-scope="scope">
                        <Money :v="total" round />
                    </template>
                </el-table-column>
                <el-table-column width="100" align="right">
                    <!-- eslint-disable-next-line vue/no-unused-vars -->
                    <template slot-scope="scope">
                        <span class="cell right percent"> 100 % </span>
                    </template>
                </el-table-column>
                <el-table-column width="100" />
            </el-table>
        </el-col>
    </el-row>
</template>
<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent,
} from 'echarts/components';

import VChart from 'vue-echarts';

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent]);

export default {
    components: { VChart },
    props: {
        isLoading: Boolean,
        chartOption: {
            type: Object,
            default: () => {},
        },
        tableData: {
            type: Array,
            default: () => [],
        },
        getPercentage: {
            type: Function,
            default: () => {},
        },
        total: {
            type: Number,
            default: 0,
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.estimate-simple-table {
    @media print {
        display: none;
    }
    .table {
        margin-top: 40px;
    }
    .table-bottom {
        margin-bottom: 40px;
    }

    .summary-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .custom-block {
        display: flex;
        .custom-label {
            color: $main-color;
            background: $main-color-fade;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            border-radius: 8px;
            margin-right: 20px;
        }
    }
}
</style>
